<script setup lang="ts">/**
 * A quick reply of the thread: the pill the pharmacist answers the Copilote
 * by.
 *
 * The label arrives served with the action it stands for, and it doubles as
 * the echo the click leaves in the thread — so a quick reply reads as what
 * the pharmacist said.
 */
import BaseButton from "@/core/components/base/BaseButton.vue";

const props = defineProps<{label: string; disabled?: boolean}>();

const emit = defineEmits<{click: []}>();

/**
 * Declared rather than left to attribute fallthrough: a disabled reply must
 * not emit, and relying on the underlying button to swallow the click would
 * make the guard invisible to the type checker.
 */
const click = () => {
    if (props.disabled === true) {
        return;
    }

    emit('click');
};
</script>

<template>
  <BaseButton
    class="bg-secondary text-primary"
    :disabled="disabled"
    @click="click"
  >
    {{ label }}
  </BaseButton>
</template>
